
























































































































import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';
import { IQuote } from '@/models';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import { roundCurrency } from '@/utils/helpers';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'QuoteTargetDiscountDrawerListItem',

  components: { ErrorAlert },

  props: {
    quote: Object as PropType<IQuote>,
    total: Number,
    exchangeRate: Number,
    currencyCode: String,
    editable: Boolean
  },

  data() {
    return {
      menu: false,
      loading: false,
      isDiscountValid: false,
      errorMessage: '',
      detailErrorMessage: '',

      targetDiscountPercent: this.quote.target_discount_percent
    };
  },

  watch: {
    'quote.target_discount_percent': {
      handler(value: number) {
        this.targetDiscountPercent = value;
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      setQuoteTargetDiscountPercent: 'quote/setQuoteTargetDiscountPercent'
    }),

    /**
     * This is used in multiple places but the function's name in invalid for its current use case
     * TODO: LH - 2024-03-07 - Refactor function name to be more generic
     */
    roundedPercentage: roundCurrency,

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    close() {
      this.menu = false;
    },

    applyQuoteTargetDiscountPercent(discountPercent: number) {
      if (this.validateForm()) {
        this.clearAllErrors();
        this.loading = true;

        this.setQuoteTargetDiscountPercent({
          id: this.quote.number,
          percentage: discountPercent
        })
          .then(() => {
            (this.$refs.targetDiscount as any).save(discountPercent);
            this.targetDiscountPercent = 0;

            this.$emit('change');
            this.close();
          })
          .catch(error => {
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
});
